import React, { useState, useEffect, useRef } from "react";
import "./whackamole.css";
import useUserInfo from "../../../Hooks/useUserInfo";
import { userGameRewards } from "../../../apis/user";
import task from "../Task";
import { useAudio } from "../../../Providers/AudioProvider";
import Swal from "sweetalert2";
import { logPageView } from "../../../components/analytics";

function WhackAMole() {
  const [score, setScore] = useState(0);
  const [activeMole, setActiveMole] = useState(null);
  const [gameTime, setGameTime] = useState(30);
  const [isPlaying, setIsPlaying] = useState(false);
  const [difficulty, setDifficulty] = useState("Easy");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [displayScore, setDisplayScore] = useState(0);
  const gameOverShown = useRef(false);
  const startTimeRef = useRef(null);
  const [gameOver, setGameOver] = useState(false);
  const { userDetails, updateUserInfo, updatewatchScreenInfo, watchScreen } =
    useUserInfo();
  const playClick = useAudio();

  const handleApiResponse = async (points) => {
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    try {
      const apiData = {
        gamePoints: points,
        gameType: "whackamole",
      };
      const res = await userGameRewards(apiData);
      if (res) {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));
        setGameOver(true);
      }
    } catch (error) {
      console.error("API call failed:", error);
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
      setGameOver(true);
    }
  };
  useEffect(() => {
    logPageView("Whackamole ", "Whackamole");
  }, []);

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  const getSettings = () => {
    switch (difficulty) {
      case "Easy":
        return { spawnRate: 1200, lifetime: 1000 };
      case "Hard":
        return { spawnRate: 500, lifetime: 400 };
      default:
        return { spawnRate: 700, lifetime: 600 };
    }
  };
  const IsPointsReached =
    watchScreen?.LoginMessage ==
    "You have already reached the maximum rewards limit"
      ? true
      : false;
  const closePopUp = () => {
    setGameOver(false);
    setScore(0);
    setGameTime(30);
  };
  useEffect(() => {
    let interval;
    if (isPlaying && !isPopupOpen) {
      if (!startTimeRef.current) {
        startTimeRef.current = Date.now();
      }
      interval = setInterval(() => {
        const elapsedTime = Math.floor(
          (Date.now() - startTimeRef.current) / 1000
        );
        const remainingTime = Math.max(0, 30 - elapsedTime);
        setGameTime(remainingTime);

        if (remainingTime === 0 && !gameOverShown.current) {
          gameOverShown.current = true;
          setIsPlaying(false);
          setDisplayScore(score);
          handleApiResponse(score);
          startTimeRef.current = null;
        }
      }, 100);
    } else {
      startTimeRef.current = null;
    }
    return () => clearInterval(interval);
  }, [isPlaying, isPopupOpen, score]);

  useEffect(() => {
    let moleTimer;
    if (isPlaying && !isPopupOpen) {
      const { spawnRate, lifetime } = getSettings();
      moleTimer = setInterval(() => {
        const randomHole = Math.floor(Math.random() * 9);
        const randomType = Math.floor(Math.random() * 8) + 1;
        setActiveMole({ hole: randomHole, type: randomType });
        setTimeout(() => {
          setActiveMole((current) =>
            current?.hole === randomHole ? null : current
          );
        }, lifetime);
      }, spawnRate);
    }
    return () => {
      clearInterval(moleTimer);
    };
  }, [isPlaying, difficulty, isPopupOpen]);

  const whackMole = (index) => {
    if (activeMole?.hole === index && isPlaying) {
      playClick();
      let pointsToAdd = 1;
      switch (difficulty) {
        case "Easy":
          pointsToAdd = 10;
          break;
        case "Medium":
          pointsToAdd = 20;
          break;
        case "Hard":
          pointsToAdd = 30;
          break;
        default:
          pointsToAdd = 1;
      }
      setScore((prev) => prev + pointsToAdd);
      setActiveMole(null);
    }
  };

  const startGame = () => {
    setScore(0);
    setDisplayScore(0);
    setGameTime(30);
    setIsPlaying(true);
    setGameOver(false);
    gameOverShown.current = false;
    startTimeRef.current = null;
  };

  const quitGame = () => {
    if (score > 0) {
      setIsPopupOpen(true);
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to exit the game?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Exit",
        reverseButtons: true,
      }).then((result) => {
        setIsPopupOpen(false);
        if (result.isConfirmed) {
          // User chose to continue playing
          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          // User chose to exit
          setDisplayScore(score);
          handleApiResponse(score);
          setIsPlaying(false);
          setScore(0);
          setGameTime(30);
          setGameOver(false);
          gameOverShown.current = false;
        }
      });
    } else {
      // If score is 0, quit without confirmation
      setDisplayScore(0);
      setIsPlaying(false);
      setScore(0);
      setGameTime(30);
      setGameOver(false);
      gameOverShown.current = false;
      handleApiResponse(0);
    }
  };

  const handleDifficultyChange = (e) => {
    setDifficulty(e.target.value);
  };

  // Add this array near the top of the component
  const moleImages = [
    { id: 1, img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/dodge.png" },
    { id: 2, img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/pepe.png" },
    { id: 3, img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/wif.png" },
    { id: 4, img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/bonk.png" },
    { id: 5, img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/shiba.png" },
    { id: 6, img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/ton.png" },
    { id: 7, img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/trump.png" },
    { id: 8, img: "https://d1ccopf5cw1hft.cloudfront.net/s3data/floki.png" },
  ];

  // Update the GameBoard component's image rendering
  const GameBoard = ({ activeMole, whackMole }) => {
    const holes = Array.from({ length: 9 }, (_, i) => i);
    return (
      <div className="whackgame-board">
        {holes.map((index) => {
          const isMoleHere = activeMole?.hole === index;
          const moleType = isMoleHere ? activeMole.type : null;

          return (
            <div key={index} className="hole" onClick={() => whackMole(index)}>
              {isMoleHere && (
                <img
                  src={moleImages.find((m) => m.id === moleType)?.img || ""}
                  alt={`Mole ${moleType}`}
                  className="mole"
                />
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div
      className="app"
      style={{
        pointerEvents: "fill",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        onClick={() => {
          toogleMenu(task, "task");
        }}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-full "
        style={{ cursor: "pointer" }}
      />
      <h2
        style={{ paddingBottom: "10px" }}
        className="text-white text-uppercase press"
      >
        Whack-A-Meme!
      </h2>
      <div className="score-time-container">
        <p className="score-text text-uppercase p-whack">Score: {score}</p>
        <p className="time-text text-uppercase p-whack">
          Time Left: {gameTime}s
        </p>
      </div>

      <div className="difficulty-control">
        <label className="text-uppercase">
          Difficulty:
          <select
            className="text-uppercase"
            value={difficulty}
            onChange={handleDifficultyChange}
            disabled={isPlaying}
            style={{ marginLeft: "10px" }}
          >
            <option value="Easy">Easy (10x Tokens)</option>
            <option value="Medium">Medium (20x Tokens)</option>
            <option value="Hard">Hard (30x Tokens)</option>
          </select>
        </label>
      </div>

      <GameBoard activeMole={activeMole} whackMole={whackMole} />
      {!isPlaying && (
        <div className="button-container">
          <button className="text-uppercase control-btn" onClick={startGame}>
            Start Game
          </button>
        </div>
      )}
      {isPlaying && (
        <div className="button-container">
          <button className="text-uppercase control-btn" onClick={quitGame}>
            Quit Game
          </button>
        </div>
      )}
      {gameOver && (
        <div className="overlay">
          <div className="full-popup">
            <div className="popup-content">
              <h2 className="epic">GAME OVER!</h2>
              <img
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                className="cancel-img"
                onClick={closePopUp}
              />
              {!IsPointsReached ? (
                <div className="row text-center">
                  <div className="col-12">
                    <div className="epic-div" style={{ padding: "30px 40px" }}>
                      <p className="pointsLabel p-whack">TOKENS EARNED</p>
                      <div className="pointsValue1">
                        <img
                          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png"
                          alt="logo"
                        />
                        <p className="pointsNumber p-whack">{displayScore}</p>
                      </div>
                    </div>
                    <p className="bottom-text p-whack">
                      Play daily to boost your score and rack up more points!
                    </p>
                  </div>
                </div>
              ) : (
                <div className="row text-center">
                  <div className="col-12">
                    <div className="epic-div">
                      <p
                        className="pointsLabel p-whack"
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          margin: "20px 0",
                          textAlign: "center",
                        }}
                      >
                        POINTS EARNED: {displayScore} <br />
                        TOKENS EARNED: NIL
                      </p>
                    </div>
                    <p className="bottom-text p-whack">
                      Keep slithering! 🐍 Rack up points and chase the high
                      score!
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default WhackAMole;
